/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import { useContext } from "react";
import { PanelsContext } from "../Context/PanelsContext";
import ImageUploading from "react-images-uploading";
import Icon2 from "../img/icon2.png";

const UploadImg = () => {
  const { setCanvasImg } = useContext(PanelsContext);
  const maxNumber = 10;
  const maxMbFileSize = 5 * 1024 * 1024;
  const onChange = (imageList) => {
    if (imageList.length < 1) {
      setCanvasImg(Icon2);
      return;
    }
    setCanvasImg(imageList[0].dataURL);
  };

  return (
    <ImageUploading
      maxNumber={maxNumber}
      onChange={onChange}
      maxFileSize={maxMbFileSize}
      acceptType={["jpg", "gif", "png", "jpeg", "svg", "webp"]}
    >
      {({ imageList, onImageUpload, onImageRemoveAll }) => (
        <div css={styles} className="uploadImg">
          {imageList.map((image) => (
            <div key={image.key} className="imageItem">
              <div className="selectedImg">
                <img src={image.dataURL} alt="canvasIcon" />
              </div>
              <div className="btnContainer">
                <button onClick={onImageRemoveAll}>Remove</button>
              </div>
            </div>
          ))}
          <button onClick={onImageUpload}>
            {imageList.length === 0 ? "Upload images" : "Update"}
          </button>
        </div>
      )}
    </ImageUploading>
  );
};

const styles = css`
  width: 100%;
  min-height: 210px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  button {
    width: 100%;
    display: flex;
    justify-content: center;
    height: 50px;
  }
  .imageItem {
    .selectedImg {
      margin-bottom: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      width: 100%;
      max-width: 320px;
      height: 80px;
      max-height: 80px;
      img {
        width: auto;
        height: auto;
        display: block;
      }
    }
    .btnContainer {
      display: flex;
      justify-content: space-between;
    }
  }
  @media (max-width: 1350px) {
    min-height: 0;
    button {
      margin-bottom: 10px;
    }
  }
`;

export default UploadImg;
